<div class="main-div">
	<div class="container">
		<div class="row justify-content-center">
			<div class="col-md-5">

				<div class="form-holder form-holder-custom">

					<div *ngIf="view == 1">
						<p class="text-center" style="margin-bottom: 0px;">
							<img src="../../assets/images/logo.png" alt="" class="img-fluid">
						</p>
						<p class="text-center text-white mb-5">Wallet</p>
						<div class="row">
							<div class="col-12 mb-4">
								<mat-card class="primary" (click)="route('createwallet')">
									<mat-card-title>Create Wallet</mat-card-title>
								</mat-card>
							</div>
							<div class="col-12">
								<mat-card class="secondary" (click)="route('import')">
									<mat-card-title>Import Wallet</mat-card-title>
								</mat-card>
							</div>
						</div>
					</div>

					<!-- <div *ngIf="view == 2">
						<p class="text-center">
							<img src="../../assets/images/nesten-logo.png" alt="" class="img-fluid">
						</p>
						<p class="text-center text-white mb-5">Wallet</p>
						<div class="row">
							<div class="col-12">
								<mat-form-field class="example-full-width">
									<input class="primary" matInput [(ngModel)]="pk" placeholder="Private Key">
								</mat-form-field>
							</div>
						</div>

						<div class="row">
							<div class="col-12">
								<button mat-stroked-button class="primary mb-2" (click)="importAccount()">Add Account</button>
							</div>
							<div class="col-12">
								<button mat-stroked-button class="primary mb-2" (click)="goView(1)">Back</button>
							</div>
						</div>
					</div> -->


					<div *ngIf="view == 3">
						<p class="text-center" style="margin-bottom: 0px;">
							<img src="../../assets/images/logo.png" alt="" class="img-fluid">
						</p>
						<p class="text-center text-white mb-5">Wallet</p>
						<div class="row">
							<!--<div class="col-12">-->
								<!--<mat-form-field class="example-full-width">-->
									<!--<input class="primary" matInput [(ngModel)]="data.username" placeholder="User name">-->
								<!--</mat-form-field>-->
							<!--</div>-->
							<!-- <div class="col-12">
								<mat-form-field class="example-full-width">
									<input class="primary" matInput placeholder="Password">
								</mat-form-field>
							</div> -->

							<div class="col-12">
								<mat-form-field class="example-full-width">
									<input matInput type="password" class="primary"  [(ngModel)]="data.password" placeholder="PIN">
								</mat-form-field>
							</div>
						</div>

						<div class="row">
							<div class="col-12 text-center">
								<button mat-stroked-button class="primary solid-gradient-btn" (click)="access()">Login</button>
							</div>
							<!-- <div class="col-md-12">
								<p class="text-center">
									<a href="" class="forgot">Forgot Password?</a>
								</p>
							</div> -->
						</div>

					</div>

					<div *ngIf="view == 4">
						<p class="text-center">
							<img src="../../assets/images/nesten-logo.png" alt="" class="img-fluid">
						</p>
						<p class="text-center text-white mb-5">Wallet</p>
						<div class="row">
							<div class="col-12">
								<mat-form-field class="example-full-width">
									<input type="text" matInput class="primary" placeholder="Username">
								</mat-form-field>
								<mat-form-field class="example-full-width">
									<input type="password" matInput class="primary" [(ngModel)]="data.password" placeholder="Password">
								</mat-form-field>
							</div>
						</div>

						<div class="row mt-2">
							<div class="col-md-12 d-flex justify-content-between">
									<button mat-stroked-button class="primary border-gradient-btn mb-1" title="Coming soon">Sign up</button>
									<button mat-stroked-button class="primary solid-gradient-btn mb-1" (click)="login()">Login</button>
							</div>
						</div>

					</div>
				</div>
			</div>
		</div>
	</div>
</div>
